<template>
  <div class="listarAssinaturas">
    <ul class="p-0 my-4" style="list-style: none" v-if="objAssinaturas.length > 0">
      <li class="px-4 py-3 mb-4 shadow text-left" v-for="(item, i) in objAssinaturas" :key="i">
        <div class="d-flex flex-lg-row flex-column justify-content-between">
          <div class="
              d-flex
              flex-lg-row flex-column
              align-items-center align-items-lg-start
              w-100
            ">
            <img v-if="item.urlImagemPromocional" :src="item.urlImagemPromocional" height="auto" style="
                margin-top: 8px;
                height: fit-content;
                border: 0;
                outline: 0;
                text-decoration: none;
                min-width: 140px;
                width: 10vw;
                line-height: 100%;
                text-align: center;
              " />
            <div class="
                d-flex
                flex-column
                align-items-center align-items-lg-start
                mx-3
                resetFont
              " style="white-space: normal">
              <strong class="pt-2">{{ item.nome }}</strong>
              <small class="mb-3" v-html="item.nomeLoja"></small>
              <div class="w-100">
                <div class="
                    d-flex
                    flex-lg-row flex-column
                    align-items-center align-items-lg-start
                    mb-3
                  ">
                  <span v-if="item.valorMensal">
                    <small class="font-weight-bold">Valor: </small>
                    {{ formatPrice(item.valorMensal) }}
                    <small>{{
                    item.modeloCobranca.recorrenciaPeriodicidadeTipo ===
                    "ANUAL"
                    ? "/anual"
                    : "/mês"
                    }}</small>
                  </span>
                  <span class="pl-4">
                    <small class="font-weight-bold">Final da Vigência:</small>
                    {{ dataDiaMes(item.dataVigenciaFim) }}
                  </span>
                </div>
              </div>
              <small v-html="item.descricao"></small>
            </div>
          </div>
          <div class="d-flex flex-column align-self-center">
            <button class="btn my-2" @click="planoCliente(item.id)">
              Acessar serviços
            </button>

            <button v-if="item.quantidadeMaximaAssociados > 1" class="btn my-2"
              @click="associados(item.pagamentoRecorrenteId)">
              Dependentes
            </button>

            <button v-if="!item.associado && MODULOS.CLUBE_DESCONTO !== true && item.recorrenciaTipo != 'ASSINATURA_PAGAMENTO_PJ'" class="btn my-2" @click="pagamentos(item.pagamentoRecorrenteId)">
              Pagamentos
            </button>
            <!-- <button v-if="!item.associado" class="btn my-2"
              @click="detalhesAssinatura(item.id, item.pagamentoRecorrenteId)">
              Trocar forma de pagamento
            </button> -->
            <button v-if="item.regulamento" class="btn my-2" data-bs-toggle="modal" data-bs-target="#exampleModal"
              @click="changeRegulamento(item.regulamento)">
              Termos e condições
            </button>
            <button type="button" @click="cancelar(item.pagamentoRecorrenteId)" class="btn btn-danger  my-2" v-if="MODULOS.CLUBE_DESCONTO !== true">
              Cancelar Assinatura
            </button>
          </div>
        </div>

        <div class="badge-light py-3" v-if="verRegulamento" v-html="item.regulamento"></div>
      </li>
    </ul>
    <div class="card p-3 mt-5" v-if="objAssinaturas.length === 0">
      Você ainda não possui assinatura contratada
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Termos e Condições</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div class="modal-body">
            <div class="modal-body-full" v-html="regulamento"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="loading"></Loading>

  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";

import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "ListarAssinaturas",
  props: ["objAssinaturas"],
  components: { Loading },
  data() {
    return {
      MODULOS: window.MODULOS,
      verRegulamento: false,
      loading: false,
      regulamento: null,
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return `R$ ${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    },
    dataDiaMes(date) {
      return this.$moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    detalhesAssinatura(id, pagamentoRecorrenteId) {
      this.$router.push(`/assinatura-detalhes/${id}/${pagamentoRecorrenteId}`);
    },
    pagamentos(id) {
      this.$router.push(`/minhas-parcelas/${id}`);
    },
    associados(pagamentoRecorrenteId) {
      this.$router.push(
        `/planos/dependentes/${pagamentoRecorrenteId}`
      );
    },
    planoCliente(id) {
      this.$router.push(`/plano-do-cliente/${id}`);
    },
    changeRegulamento(regulamento) {
      this.regulamento = regulamento;
    },
    cancelar(pagamentoRecorrenteId) {
      this.loading = true;
      apiService
        .cancelarAssinatura(pagamentoRecorrenteId)
        .then(() => {
          this.$swal({
            title: "Solicitação de cancelamento",
            text: "Sua solicitação foi realizada com sucesso, em breve você receberá mais informações por e-mail.",
          }).then(() => {
            this.$router.push(`/minhas-recorrencias`);
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
          this.$swal({ text: "Não foi possível realizar o cancelamento" });
        });
    },
    regulamneto(html) {
      this.$swal({
        title: "Regulamento",
        html: `<div style="overflow: auto;max-height: 70vh;">${html}</div>`,
        confirmButtonText: "Fechar",
      });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
